import { compose, isNil, not } from 'ramda';

export const cleanse = (obj) => {
	Object.keys(obj).forEach((key) => {
		const value = obj[key];
		// removing null or undefined values
		if (value === null || value === undefined || value === '') {
			delete obj[key];
		} else {
			const type = typeof value;
			// if array or object literal then recursively cleanse
			if (type === 'object') {
				cleanse(value);
				// removing undefined from array (because cleanse will turn all null to undefined in array)
				if (Array.isArray(value)) {
					obj[key] = value.filter(compose(not, isNil));
				}
				// if object literal or array is empty remove it
				if (!Object.keys(value).length) {
					delete obj[key];
				}
			}
		}
	});
	return obj;
};
